import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo, FileSelectorViewModel } from "uicomponents";
import  { SetMinBenefitPercentageView } from "./setMinBenefitPercentage-view"
import { downloadFile, getAsNumber } from "src/uicomponents/components/utilities";
import { ExcelExporter } from "src/common/utilities";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ProductSearchableSelectorViewModel } from "../productSearch/productSearchableSelector/productSearchableSelector-viewModel";
import moment from "moment";

export class SetMinBenefitPercentageViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تنظیم مینیمم درصد احتیاط';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.fileSelector = new FileSelectorViewModel(this);
        this.products = ObservableArray.create<MinBenefitPercentage>();
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new SetMinBenefitPercentageView();
    }
    public getTypeId(): string {
        return "VM-42DD06DF-BD30-4943-8A65-B4001E35F82E"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set products(v: ObservableArray<MinBenefitPercentage>) { this._products = v; } public get products(): ObservableArray<MinBenefitPercentage> { return this._products;} private _products: ObservableArray<MinBenefitPercentage>;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PricingServices/AllBenefitPercentages',{
                FilteringInformation:filteringInformation
            });
            let rowNumber = 1;
            this.products.update(...result.CustomBenefitPercentages.map(q=>{
                let r = new MinBenefitPercentage(this);
                r.rowNumber = rowNumber++;
                r.productId = q.ProductId;
                r.productName = q.ProductName;
                r.productCode = q.ProductCode;
                r.productCarModel = q.CarBrand;
                r.benefitPercentage = q.BenefitPercentage;
                r.minBenefitPercentage = q.MinBenefitPercentage;
                r.minBenefitModifier = q.MinBenefitModifier;
                r.minBenefitModifyDate = q.MinBenefitModifyDate == null ? null : moment.utc(q.MinBenefitModifyDate);
                r.maxSetBenefitPercentage = q.MaxSetBenefitPercentage;
                r.minSetBenefitPercentage = q.MinSetBenefitPercentage;
                r.isEdited = false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    async import(){
        try {
            let errors :string[]= [];
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PricingServices/ImportCustomBenefitPercentages',{
                ExcelFile : this.fileSelector.filecontent
            });
            if (result.IsSuccessful == false) {
                throw 'error';
            }
            await this.messageBoxConfirmSuccess('مینیمم درصد احتیاط با موفقیت بروزسانی شد.','عملیات موفق');
            this.refresh();
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async export(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer("/Complex/PricingServices/ExportCustomBenefitPercentages", {
            });
            downloadFile(result.ExcelFile,'مینیمم درصد احتیاط.xlsx');
            if(result.IsSuccessful == true){
                await this.messageBoxConfirmSuccess("با موفقیت دانلود شد.","مینیمم درصد احتیاط");
            }

        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async createMinBenefitPercentage() {
        let result = await this.showPopup(new CreateMinBenefitPercentage(this));
        this.refresh();    
    }

    async save(minBenefitPercentage: MinBenefitPercentage): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/PricingServices/UpdateMinBenefitPercentage',{
            ProductId:minBenefitPercentage.productId,
            MinBenefitPercentage: minBenefitPercentage.minBenefitPercentage
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
        this.refresh();
    }
}

export class MinBenefitPercentage extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:SetMinBenefitPercentageViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set minBenefitPercentage(v: number) { 
        this._minBenefitPercentage = getAsNumber(v,true); 
        this.isEdited = true;
    } public get minBenefitPercentage(): number { return this._minBenefitPercentage;} private _minBenefitPercentage: number;
    public set minBenefitModifyDate(v: moment.Moment) { this._minBenefitModifyDate = v; } public get minBenefitModifyDate(): moment.Moment { return this._minBenefitModifyDate;} private _minBenefitModifyDate: moment.Moment;
    public set minBenefitModifier(v: string) { this._minBenefitModifier = v; } public get minBenefitModifier(): string { return this._minBenefitModifier;} private _minBenefitModifier: string;
    public set minSetBenefitPercentage(v: number) { this._minSetBenefitPercentage = v; } public get minSetBenefitPercentage(): number { return this._minSetBenefitPercentage;} private _minSetBenefitPercentage: number;
    public set maxSetBenefitPercentage(v: number) { this._maxSetBenefitPercentage = v; } public get maxSetBenefitPercentage(): number { return this._maxSetBenefitPercentage;} private _maxSetBenefitPercentage: number;
    public set benefitPercentage(v: number) { this._benefitPercentage = v; } public get benefitPercentage(): number { return this._benefitPercentage;} private _benefitPercentage: number;
    public set isEdited(v: boolean) { this._isEdited = v; } public get isEdited(): boolean { return this._isEdited;} private _isEdited: boolean;
    
    protected _typedParent:SetMinBenefitPercentageViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
   
    verify():string[]{
        let result :string[] =[];
        return result;
    }

    async confirm(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت مینیمم درصد احتیاط');
                return;
            }
            this.isLoading = true;
            await this._typedParent.save(this);
            await this.messageBoxConfirmSuccess(this.getSuccessMessage(),'عملیات موفق');
            this.isEdited = false;
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    getSuccessMessage(): string {
        return 'مینیمم درصد احتیاط با موفقیت تنظیم شد.';
    }

}

export class CreateMinBenefitPercentage extends MinBenefitPercentage implements IPopup {
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:SetMinBenefitPercentageViewModel) {
        super(parent);
        this.sourceProductSearch = new ProductSearchableSelectorViewModel(this,true);
 
        this.sourceProductSearch.onSelectionChanged = p=>{
            this.productCode = p.productCode;
            this.productName = p.productName;
            this.productId = p.id;
        };
   }
    
    public set sourceProductSearch(v: ProductSearchableSelectorViewModel) { this._sourceProductSearch = v; } public get sourceProductSearch(): ProductSearchableSelectorViewModel { return this._sourceProductSearch;} private _sourceProductSearch: ProductSearchableSelectorViewModel;
    
    verify():string[]{
        let result :string[] =[];
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت مینیمم درصد احتیاط');
                return;
            }
            this.isLoading = true;
            await this._typedParent.save(this);
            await this.messageBoxConfirmSuccess(this.getSuccessMessage(),'عملیات موفق');
            this.closePopup("");
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    closePopup(result: any) {
        
    }
    getSuccessMessage(): string {
        return 'مینیمم درصد احتیاط با موفقیت تنظیم شد.';
    }

}
